import { render, staticRenderFns } from "./LogSideBar.vue?vue&type=template&id=a71a8f2c&scoped=true&"
import script from "./LogSideBar.vue?vue&type=script&lang=js&"
export * from "./LogSideBar.vue?vue&type=script&lang=js&"
import style0 from "./LogSideBar.vue?vue&type=style&index=0&id=a71a8f2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71a8f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a71a8f2c')) {
      api.createRecord('a71a8f2c', component.options)
    } else {
      api.reload('a71a8f2c', component.options)
    }
    module.hot.accept("./LogSideBar.vue?vue&type=template&id=a71a8f2c&scoped=true&", function () {
      api.rerender('a71a8f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/LogSideBar.vue"
export default component.exports